import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import './SelectMeter.scss'
import { IDateInputComponent, IMultiSelectInputComponent, IPassFailInputComponent, ISelectInputComponent, ITextInputComponent, StepComponentTypes } from "interfaces/sw/SWInterfaces";
import { updateSelectInput, updateMultiSelectInput, updateTextInput, updateDateInput, updatePassFailInput } from "store/manageSW/manageSWActions";
import { IMasterDataItem } from "interfaces/masterData/masterDataInterfaces";

interface ISelectMeter {
  inputComponent: ISelectInputComponent | IMultiSelectInputComponent | ITextInputComponent | IDateInputComponent | IPassFailInputComponent;
  stepGuid: string;
  meters: IMasterDataItem[];
}

const SelectMeter: React.FC<ISelectMeter> = ({
  inputComponent,
  stepGuid,
  meters
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (inputComponent.meterId !== undefined
      && meters.length > 0) {
      const meter = meters.find(x => x.guid === inputComponent.meterId)
      if (meter === undefined) {
        dispatchMeterUpdate(undefined, undefined)
      }
    }
  }, [inputComponent]);

  const onChangeMeter = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const meterItem = meters.find(
      (m) => m.guid === e.target.value
    ) ?? {
      guid: e.target.value,
      value: e.target.value,
      active: true,
    };
    dispatchMeterUpdate(meterItem.guid, meterItem.code);
  }

  const dispatchMeterUpdate = (guid?: string, code?: string) => {
    if (inputComponent.type === StepComponentTypes.SelectInput) {
      dispatch(updateSelectInput({
        stepGuid,
        component: {
          ...inputComponent,
          meterId: guid,
          meterCode: code,
        },
      }));
    } else if (inputComponent.type === StepComponentTypes.MultiSelectInput) {
      dispatch(updateMultiSelectInput({
        stepGuid,
        component: {
          ...inputComponent,
          meterId: guid,
          meterCode: code,
        },
      }));
    } else if (inputComponent.type === StepComponentTypes.TextInput) {
      dispatch(updateTextInput({
        stepGuid,
        component: {
          ...inputComponent,
          meterId: guid,
          meterCode: code,
        },
      }));
    } else if (inputComponent.type === StepComponentTypes.DateInput) {
      dispatch(updateDateInput({
        stepGuid,
        component: {
          ...inputComponent,
          meterId: guid,
          meterCode: code,
        },
      }));
    } else if (inputComponent.type === StepComponentTypes.PassFailInput) {
      dispatch(updatePassFailInput({
        stepGuid,
        component: {
          ...inputComponent,
          meterId: guid,
          meterCode: code,
        },
      }));
    }
  }

  return (
    <>
      <select
        className="meterDropdown"
        onChange={(e) => onChangeMeter(e)}
        value={inputComponent.meterId ?? ""}
      >
        <option value="" key=""></option>
        {meters.map((t) => (
          <option key={t.guid + "-" + t.code} value={t.guid}>
            {t.code}
          </option>
        ))}
      </select>
    </>
  );
}

export default SelectMeter;

